import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Member } from './models/member.model';
import { ApiService } from '../../shared/services/api.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { catchError } from 'rxjs';
import { ExistenceChecker } from '../../shared/interfaces/existence-checker.interface';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
@Injectable({
  providedIn: 'root'
})
export class MembersService extends ApiService<Member> implements ExistenceChecker<string, number> {

  readonly _baseUrl: string;

  readonly searchFields = ['firstName', 'lastName', 'email'];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}members/`;    
  }

  exists(email: string, memberId?: number) {
    let params = new HttpParams().set('email', email);
    if (memberId !== undefined && memberId !== null) {
      params = params.set('memberId', memberId.toString());
    }
    return this.http.get<boolean>(`${this._baseUrl}email-exists`, { params: params }).pipe(
        catchError(this.handleError)
    );
  }  
}
